import '../assets/cssnew/header_panel.css'
import logo from '../assets/images/logo-rectangle-v1.svg'
import { Menu } from '../assets/icones/icones';
import React, {Fragment, useState} from 'react';
import clientconfigwebapp from "../clientconfigwebapp";
import MenuIcon from '@mui/icons-material/Menu';
import {Button} from "@mui/material";
import {Link,NavLink} from "react-router-dom";
import logo_web_app from "../assets/images/logo.png";
////function Header_Panel_Mobile_Pc(props) {
const Header_Panel_Mobile_Pc = (props) => {

    const { handle_Open_menu } = props;


        const [status , setStatus] = useState(false);


  const menuOpenHandler = () => {
      handle_Open_menu(true)
        // const back = document.querySelector('.back_dark')
        // const menu = document.querySelector('.panel_aside')
        // back.style.display = 'block'
        // menu.style.left = '0'
  }
  const userMenuOpen = () => {
    const menu = document.querySelector('.user_menu')
    if(status == false) {
          menu.style.display = 'block'
          setStatus(true)
    }else {
      menu.style.display = 'none'
      setStatus(false)
    }

  }




  return (
    <Fragment>
        <header className='header_container flexRowBetCenter'>
            <div className={"box_header_mobile"} style={{display: "none"}}>
                    <span className='menu_btn_pnael_mobile menu_header_panel_mob' onClick={menuOpenHandler}>
                    <Menu/>
                    </span>

                <div className="header-mobile-panel-logo">
                    <Link to={"/"}><img src={logo_web_app}/></Link>
                </div>



            </div>

            <div className={"btns-top-header-pc"} style={{display: 'flex'}}>
                <a href={"/"} style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    padding: '8px',
                    background: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    flexDirection: 'row-reverse',
                    marginLeft: '8px'
                }}><span>صفحه اصلی</span>
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2137_1927)">
                            <path
                                d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z"
                                fill="#4B5563"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_2137_1927">
                                <rect width={24} height={24} fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a>
                <a href={"/products"} style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    padding: '8px',
                    background: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    flexDirection: 'row-reverse',
                    marginLeft: '8px'
                }}><span>لیست محصولات</span>
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_0_3047)">
                            <path
                                d="M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
                                fill="#4B5563"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_0_3047">
                                <rect width={24} height={24} fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a></div>


        </header>
    </Fragment>
  );
}

export default Header_Panel_Mobile_Pc;